<script>
export default {
  props: {
    title: String,
  },
  data() {
    return {
      isActive: false,
      id: Math.floor(Math.random() * 10000),
    }
  },
  methods: {
    handleHeaderClick() {
      this.isActive = !this.isActive
    },
  },
}
</script>

<template>
  <div>
    <div
      role="tab"
      :aria-expanded="isActive"
      :aria-controls="`el-collapse-content-${id}`"
      :aria-describedby="`el-collapse-content-${id}`"
      :class="$style.wrapper"
    >
      <div
        :id="`el-collapse-head-${id}`"
        role="button"
        :class="$style.header"
        @click="handleHeaderClick"
      >
        <BaseIcon :class="$style['header-icon']" :name="(isActive) ? 'minus' : 'plus'" />
        <slot name="title">{{title}}</slot>
      </div>
      <div
        v-show="isActive"
        :id="`el-collapse-content-${id}`"
        role="tabpanel"
        :aria-hidden="!isActive"
        :aria-labelledby="`el-collapse-head-${id}`"
        :class="$style.content"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.wrapper {
  background: white;
}
.header {
  padding: 15px;
  font-size: ms(1);
  font-weight: bold;
  cursor: pointer;

  &-icon {
    margin-right: 10px;
  }
}
.content {
  padding: 5px 15px;
}
</style>
